import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "@/hooks/useScrollAnimation";
import LiveTerminal from "./LiveTerminal";
import "./AIFeatureSection.scss";

const PlusIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
    <path d="M6 1v10M1 6h10" />
  </svg>
);

const ITEMS = ["conversational", "predictive", "automation"] as const;

const AIFeatureSection: React.FC = () => {
  const { t } = useTranslation();
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section className="ai-feature-section" ref={ref}>
      <div id="ai-feature-section" className="container">
        <div className="ai-grid">
          <div className={`reveal${isVisible ? " in" : ""}`}>
            <span className="sec-label ai-label">{t("aiFeature.label")}</span>
            <h2 className="sec-title ai-title">
              {(() => {
                const title = t("aiFeature.title");
                const hl = t("aiFeature.titleHighlight");
                const [before, after = ""] = title.split(hl);
                return <>{before}<em>{hl}</em>{after}</>;
              })()}
            </h2>
            <div className="ai-list">
              {ITEMS.map((k, i) => (
                <div
                  key={k}
                  className={`ai-item${openIdx === i ? " open" : ""}`}
                  onClick={() => setOpenIdx(openIdx === i ? -1 : i)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === "Enter" && setOpenIdx(openIdx === i ? -1 : i)}
                  aria-expanded={openIdx === i}
                >
                  <div className="ai-item-num">0{i + 1}</div>
                  <div>
                    <div className="ai-item-title">{t(`aiFeature.${k}.title`)}</div>
                    <div className="ai-item-desc">{t(`aiFeature.${k}.description`)}</div>
                  </div>
                  <div className="ai-item-plus"><PlusIcon /></div>
                </div>
              ))}
            </div>
          </div>
          <div className={`reveal${isVisible ? " in" : ""}`} style={{ transitionDelay: "0.15s" }}>
            <LiveTerminal />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIFeatureSection;
